import React from "react";
import {
  ListItem,
  ListItemButton,
  ListItemText,
  Tooltip,
  IconButton,
} from "@mui/material";
import ArrowRight from "@mui/icons-material/ArrowRight";
import PropTypes from "prop-types";
import { MButton } from "src/M_Components";
import { useTranslation } from "react-i18next";
import "./UserSettingsMenu.css";

export default function UserSettingsMenu({
  handleSettings,
  handleLogout,
  handleChangeLng,
}) {
  const { t } = useTranslation();

  //============================================================================================================
  // Settings Menu Options
  //============================================================================================================
  const lastMenus = [
    {
      MenuLabel: t("SettingsSpan"),
      onClick: handleSettings,
      MenuIcon: <i className="pi pi-cog" />,
      code: "Settings",
    },
    {
      MenuLabel: t("LogoutSpan"),
      onClick: handleLogout,
      MenuIcon: <i className="pi pi-sign-out" />,
      code: "Logout",
    },
  ];

  //============================================================================================================
  // Renders the user settings menu
  //============================================================================================================
  return (
    <div className="userSettingsMenu">
      {/* Render the Button List from Last Menus */}
      {lastMenus.map((menu, key) => (
        <ListItem
          component="div"
          disablePadding
          className="userSettingsItem"
          key={menu.MenuLabel || key}
        >
          <ListItemButton
            disableRipple
            className="userSettingsButton"
            onClick={() => menu.onClick()}
          >
            <ListItemText
              primary={
                <span className="menuLabelContainer">
                  <span className="menuLabelText">{t(menu.MenuLabel)}</span>
                </span>
              }
            />
          </ListItemButton>

          <Tooltip title={t(menu.MenuLabel)} placement="right">
            <IconButton
              size="large"
              disableRipple
              onClick={() => menu.onClick()}
              data-cy={menu.code}
              className="userSettingsIconButton"
            >
              {menu.MenuIcon}
              <ArrowRight className="userSettingsArrow" />
            </IconButton>
          </Tooltip>
        </ListItem>
      ))}

      {/* Language Buttons Section*/}
      <div className="language-buttons">
        <MButton
          none
          noHover
          marginNone
          tooltip={"EN"}
          onClick={() => handleChangeLng("en")}
          icon={<img src="./icons/flagIcons/EN.png" alt="EN" />}
        />
        <MButton
          none
          noHover
          marginNone
          tooltip={"ES"}
          onClick={() => handleChangeLng("es")}
          icon={<img src="./icons/flagIcons/ES.png" alt="ES" />}
        />
        <MButton
          none
          noHover
          marginNone
          tooltip={"PT"}
          onClick={() => handleChangeLng("pt")}
          icon={<img src="./icons/flagIcons/PT.png" alt="PT" />}
        />
      </div>
    </div>
  );
}

UserSettingsMenu.propTypes = {
  handleSettings: PropTypes.func,
  handleLogout: PropTypes.func,
  handleChangeLng: PropTypes.func,
};
